import Api from '../../../Api'
import { all, put, takeEvery } from 'redux-saga/effects'
import { combineReducers } from 'redux'
import createTableFetcher from 'common/reducer/createTableFetcher'
// import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'

export const types = {
    SET_SAAS: 'LICENSES/SET_SAAS',
}

const getFetcher = (state) => state.waas.licenses.fetcher

export const fetcher = createTableFetcher('licenses', Api.fetchLicenses, getFetcher)


export const actions = {
    setSaaS: (val) => ({ type: types.SET_SAAS, val }),
    ...fetcher.actions
}

export const initialState = {
    isSaaS: false,
    ...fetcher.initialState
}

const licenses = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_SAAS:
            return {
                ...state,
                isSaaS: action.val,
            };
        default:
            return state;
    }
}

export default combineReducers({
    licenses,
    fetcher: fetcher.reducer
});

function* setSaaS(action){
    yield put(actions.trigger({isSaaS:action.val})); 
}

function* licensesCustomFlow() {
    yield takeEvery(types.SET_SAAS, setSaaS);
}

export function* licensesSaga() {
    yield all([
        licensesCustomFlow(),
        fetcher.saga(),
    ])
}